import { Fragment, useEffect } from 'react';

import Checkbox from 'bloko/blocks/checkbox';
import FormSpacer from 'bloko/blocks/form/FormSpacer';
import Select, { Option } from 'bloko/blocks/select';

import useTrls from 'hooks/translation/useTrls';

import InputWithMultiDatePicker from 'components/InputWithMultiDatePicker';

import fetchIncomeExpenseData from 'components/Admin/Reports/IncomeExpenseReport/fetchIncomeExpenseData';
import IncomeExpenseTable from 'components/Admin/Reports/IncomeExpenseReport/IncomeExpenseTable';
import ReportWrapper from 'components/Admin/Reports/ReportWrapper';

import {
    INCOME_EXPENSE_INITIAL_STATE,
    IncomeExpenseReportType,
    setDates,
    setTypeReport,
    setVat,
} from 'store/models/incomeExpense';
import { useDispatch, useSelector } from 'store/utils';

const IncomeExpenseReport = () => {
    const { from, to, typeReport, vat, isLoad } = useSelector((state) => state.incomeExpense);
    const dispatch = useDispatch();
    const trl = useTrls();

    const onClickClear = () => {
        dispatch([
            setDates({ from: INCOME_EXPENSE_INITIAL_STATE.from, to: INCOME_EXPENSE_INITIAL_STATE.to }),
            setTypeReport(INCOME_EXPENSE_INITIAL_STATE.typeReport),
            setVat(INCOME_EXPENSE_INITIAL_STATE.vat),
        ]);
    };

    useEffect(() => {
        dispatch(fetchIncomeExpenseData());
    }, [dispatch]);

    return (
        <ReportWrapper
            title={trl('admin.SectionTabs.monthlyIncomeExpense')}
            filter={
                <Fragment>
                    <InputWithMultiDatePicker
                        action={(from, to) => dispatch(setDates({ from, to }))}
                        from={from}
                        to={to}
                    />
                    <FormSpacer>
                        <Select
                            value={typeReport}
                            onChange={({ target }) => dispatch(setTypeReport(target.value))}
                            flexible
                        >
                            {Object.values(IncomeExpenseReportType).map((value) => (
                                <Option key={value} value={value}>
                                    {trl(`admin.incomeExpenseReport.Filter.type.${value}`)}
                                </Option>
                            ))}
                        </Select>
                    </FormSpacer>
                    <FormSpacer>
                        <Checkbox onChange={() => dispatch(setVat(!vat))} checked={vat}>
                            {trl('admin.incomeExpenseReport.vat')}
                        </Checkbox>
                    </FormSpacer>
                </Fragment>
            }
            content={<IncomeExpenseTable />}
            isLoadContent={isLoad}
            onClickSearch={() => dispatch(fetchIncomeExpenseData())}
            onClickClear={onClickClear}
        />
    );
};

export default IncomeExpenseReport;
